<template>
    <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm10 md10>
            <v-card class="elevation-12">
              <v-toolbar color="red" dark>
                <v-toolbar-title>Project Survey</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form v-if="user.data.competition_change">
                    <div v-for="question in filteredQuestions">
                      <p class="title mb-3">{{ question.question }} <span v-if="question.answer_required">*</span></p>
                      <span v-html="question.description"></span>
                      <v-text-field clearable multi-line v-model="question_answers[question.id]" :counter="question.answer_max"  :maxLength="question.answer_max" v-validate="{required: (question.answer_required == 1)}" append-icon="fa fa-question" color="black" :error-messages="errors.collect(question.question)">
                      </v-text-field>
                    </div>
                </v-form>
              </v-card-text>
              <v-card-actions>
                 <v-btn color="primary" left @click.prevent="rollBack" >Previous</v-btn>
                <v-spacer></v-spacer>                
                <v-btn color="success"  :disabled="!! (errors.any())" right @click.prevent="proceed">Next</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app> 
</template>
<script>
  export default {
    props : ['user','questions'],
    data(){
      return {
        question_answers : {},
      }
    },
    computed : {
      filteredQuestions () {
        return this.questions.filter(question => (question.competition_id === null || this.user.data.competition_id == question.competition_id || this.user.data.category_id == question.category_id) && question.enabled === 1);
      },
      isDisabled(){
        if(Object.keys(this.question_answers).length === this.filteredQuestions.length){
          return false;
        }
        return true;
      }
    },
    methods : {
      proceed (){
          let answers = []
          for (let key in this.question_answers ) {
            answers.push({ question_id : key , answer : this.question_answers[key]})
          }
          this.user.data.answers = answers;
          this.$noty.success('Let\'s Move on to the next step.');
          // if(this.user.data.city_accommodation) {
          //   this.$noty.info('Accommodation price is set automatically depending on the number of members');
          // }
          this.$emit('completed',this.user);
      },
      rollBack(){
         this.$emit('rollback',this.user)
      }
    }
  };
</script>
<style>
    
</style>


// WEBPACK FOOTER //
// src/components/Registeration/Questions.vue